<div class="home-news-content py-4 px-2 py-sm-5 px-sm-0 mt-ncs mb-4">
  <div class="container">
    <div class="background-image">
      <div class="container">
        <div class="bg-light p-5 mb-4 rounded-3">
          <div class="container-fluid py-5">
            @if (hasHomeNewsMetadata) {
            <ds-text-section [sectionId]="'site'"
                             [textRowSection]="homeNewsSection"
                             [site]="(site$ | async)">
            </ds-text-section>
          } @else {
            <div class="d-flex flex-wrap">
              <div>
                <h1 class="display-2">DSpace Cris 9</h1>
                <p class="lead">DSpace is the world leading open source repository platform that enables organisations to:</p>
              </div>
            </div>
            <ul>
              <li>easily ingest documents, audio, video, datasets and their corresponding Dublin Core metadata
              </li>
              <li>open up this content to local and global audiences, thanks to the OAI-PMH interface and Google Scholar optimizations
              </li>
              <li>issue permanent urls and trustworthy identifiers, including optional integrations with handle.net and DataCite DOI</li>
            </ul>
            <p>Join an international community of <a href="https://wiki.lyrasis.org/display/DSPACE/DSpace+Positioning"
                                                     target="_blank" role="link" tabindex="0">leading institutions using DSpace</a>.
            </p>
          }
          </div>
        </div>
      </div>
      <small class="credits">Photo by
        <a href="https://www.pexels.com/@inspiredimages">&#64;inspiredimages</a>
      </small>
    </div>
  </div>
</div>
